import { getClass } from 'app/frontend/base/services/characterValues'
import { RaidPlanActor } from 'app/frontend/types/custom/RaidPlan'
import CharacterRole from 'app/frontend/types/custom/CharacterRole'
import {
  roleToSimpleRole,
  simpleCharacterRoles,
} from 'app/frontend/types/custom/SimpleCharacterRole'

type SortSpecialization = {
  id: number
  name: string
  defaultRole: CharacterRole
  icon?: string
  className?: string
  classId?: number
}

type TeamPlanActorSortMeta = {
  className?: string
  classLabel: string
  spec?: SortSpecialization
  roleIndex: number
  sortKey: string
}

const getTeamPlanActorSortMeta = (
  actor: RaidPlanActor,
  specializations: SortSpecialization[],
  unknownLabel: string,
): TeamPlanActorSortMeta => {
  const className = getClass(actor.class_id?.toString() ?? '')
  const spec = specializations.find(
    (specialization) => specialization.id === actor.spec_id,
  )
  const classLabel = className || unknownLabel
  const roleIndex = (() => {
    if (!spec) return Number.MAX_SAFE_INTEGER
    const simpleRole = roleToSimpleRole(spec.defaultRole)
    const index = simpleCharacterRoles.findIndex((role) => role === simpleRole)
    return index >= 0 ? index : Number.MAX_SAFE_INTEGER
  })()
  const sortKey = `${classLabel} ${spec?.name ?? ''}`.trim()

  return {
    className,
    classLabel,
    spec,
    roleIndex,
    sortKey,
  }
}

export { getTeamPlanActorSortMeta }
export type { TeamPlanActorSortMeta }
